/**
 * ** FNS Rooms **
 *
 * @exports bs_21
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_21
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      let lang;

      thn.domReady().then(function () {

        lang = (ctx.getHtmlLang() || thn.parseUrlParameter('idioma') || 'es').substr(0, 2);
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }

        reject('no_language');
      });
    });
  };

  /**
     * @memberOf module:bs_21
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    // https://reservas.fnsbooking.com/busqueda.php?REFERENCIA=&idioma=fr&pfe=2907&f_entrada=17/11/2025&f_salida=18/11/2025&accion=F&release=500&ciudad=&DISPOSITIVO=&datos=743331080--5221--------------&orden=&currency=&session=&ip=35.191.79.101&codigopromocional=&oferta_id=&tipo_habitacion_id=&ocupacion=2&mejortarifa=&codigoexclusivo=&moneda_forzada=

    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/busqueda\.php/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    url.searchParams.set('f_entrada', '[date_begin]');
    url.searchParams.set('f_salida', '[date_end]');
    url.searchParams.set('idioma', '[language]');
    url.searchParams.set('ocupacion', '[adults]');
    url.searchParams.set('currency', '[currency]');

    // Export into ctx.newUrl
    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     * @memberOf module:bs_21
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    const fnsCurrencies = {
      2: 'USD',
      3: 'PEN',
      4: 'CLP',
      5: 'ARS',
      6: 'GBP',
      7: 'BRL',
      8: 'MXN',
      9: 'BOB',
      10: 'COP',
      11: 'DOP',
      12: 'PHP',
    };

    // Dates
    const dateBegin = (thn.parseUrlParameter('entrada') || thn.parseUrlParameter('f_entrada') || document.querySelector('#entrada')?.value)?.replace(/\D*(\d+)\D+(\d+)\D+(\d+)\D*/, '$3/$2/$1');
    const dateEnd = (thn.parseUrlParameter('salida') || thn.parseUrlParameter('f_salida') || document.querySelector('#salida')?.value)?.replace(/\D*(\d+)\D+(\d+)\D+(\d+)\D*/, '$3/$2/$1');

    if (!dateBegin || !dateEnd) {
      return null;
    }

    const nights = thn.daysBetween(dateBegin, dateEnd);
    widgetData.dateBegin = dateBegin;
    widgetData.dateEnd = dateEnd;

    // Prices & Guests
    const prices = [...document.querySelectorAll('#content-selector-habitacion-tarifa > div.col-md-8 > div.m-t-10 > div > table > tbody > tr')].map((el) => thn.parseNumber(el.querySelector('.preciomostrar_ficha, .info-precio')?.textContent)).filter(Boolean);
    const adults = thn.parseNumber(document.querySelector('.ocupacion.desgloseth .tooltip4 span, .f-14.texto-color-4.t-a-c.t-b')?.textContent) || 2;
    widgetData.adults = adults;
    widgetData.children = 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Hotel Currency
    const currencyParam = thn.parseUrlParameter('currency');
    if (!thn.empty(prices) && nights) {
      widgetData.price = Math.min(...prices) / nights;
      if (thn.empty(currencyParam)) {
        const currency = thn.parseCurrency(document.querySelector('.info-precio, #selector-monedas > option[selected]')?.textContent || document.querySelector('#precio-euros-ota')?.textContent) || 'EUR';
        widgetData.currency = currency;
      } else {
        widgetData.currency = fnsCurrencies[parseInt(thn.parseUrlParameter('currency'), 10)] || 'EUR';
      }
      widgetData.set = true;
    } else {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_21
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const totalPriceEl = document.querySelector('#dd_precio_total')?.textContent;
    widgetData.price = totalPriceEl && thn.parseNumber(totalPriceEl);
    widgetData.currency = ctx.tmpSession.currency || thn.parseCurrency(totalPriceEl);
    widgetData.bookingId = document.querySelector('.localizador')?.textContent;
    widgetData.dateBegin = document.querySelector('.booking-data-item:nth-child(4) dd')?.textContent?.replace(/\D*(\d+)\D+(\d+)\D+(\d+)\D*/, '$3/$2/$1');
    widgetData.dateEnd = document.querySelector('.booking-data-item:nth-child(5) dd')?.textContent?.replace(/\D*(\d+)\D+(\d+)\D+(\d+)\D*/, '$3/$2/$1');

    return widgetData;
  };

  return engine;

}

export { factory };
